import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "flex w-full justify-between items-end gap-x-4pt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", { class: "flex-none text-sm" }, " Permit Fee ", -1)
const _hoisted_4 = { class: "text-sm leading-6 text-gray-500" }
const _hoisted_5 = {
  key: 0,
  class: "mt-1 flex w-full justify-between items-end gap-x-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", { class: "flex-none text-sm" }, " State Seal ", -1)
const _hoisted_7 = { class: "text-sm leading-6 text-gray-500" }
const _hoisted_8 = { class: "mt-1 flex w-full justify-between items-end gap-x-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", { class: "flex-none text-sm" }, " Processing Fee (3%) ", -1)
const _hoisted_10 = { class: "text-sm leading-6 text-gray-500" }
const _hoisted_11 = { class: "mt-2 flex w-full justify-between items-end gap-x-4 border-t border-gray-900/5 pt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", { class: "flex-none text-sm font-bold" }, " Total Amount Due ", -1)
const _hoisted_13 = { class: "text-sm leading-6 text-gray-950 font-bold" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { id: "payment-element" }, null, -1)

import api from '@/utilities/api'

	import {
		onMounted,
		ref
	} from 'vue'

	
	const __default__ = { name: 'StripePaymentForm' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: { 
		permit: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props, { expose }) {

const props = __props;

	

	onMounted(async () => {
		initializeStripe()
	})

	const email = ref('')
	const emailError = ref(false)
	const clientSecret = ref("")

	// eslint-disable-next-line
	const stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY)

	let elements

	const stripeError = ref("")
	const stripeLoading = ref(false)
	

	async function initializeStripe() {
		try {
			stripeLoading.value = true
			const body = {
				feeTotal: props.permit.permit.feeTotal,
				permitId: props.permit.permit.id,
				permitNumber: props.permit.permit.permitNumber
			}
		
			const response = await api("post", "fmDataApi", "/create-payment-intent", body)
			clientSecret.value = response.clientSecret

			const appearance = {
				theme: 'stripe'
			}
			elements = stripe.elements({ appearance, clientSecret: response.clientSecret})

			const paymentElementOptions = {
				layout: "tabs"
			}

			const paymentElement = elements.create("payment", paymentElementOptions)
			paymentElement.mount("#payment-element")
		}
		catch(e) {
			console.error(e)
		}
		finally {
			stripeLoading.value = false
		}
	}

	async function submit() {
		stripeError.value = ""
		emailError.value = false
		if(!email.value) {
			emailError.value = true
			document.getElementById("email")?.focus()
			return
		}
		try {
			stripeLoading.value = true
	
			const response = await stripe.confirmPayment({
				elements,
				confirmParams: {
					// Make sure to change this to your payment completion page
					return_url: window.location.href,
					payment_method_data: {
						billing_details: {
							email: email.value
						}
					}
				}
			})

			const error = response?.error

			if (error?.type === "card_error" || error?.type === "validation_error") {
				stripeError.value = error.message
			}
			else {
				stripeError.value = "An unexpected error occurred."
			}
		}
		catch(e) {
			console.error(e)
		}
		finally {
			stripeLoading.value = false
		}
	}

	expose({
		clientSecret
	})

return (_ctx: any,_cache: any) => {
  const _component_tw_loading = _resolveComponent("tw-loading")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_button = _resolveComponent("v-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("dd", _hoisted_4, _toDisplayString(_ctx.$filters.usd(__props.permit?.permit?.feePermit) || "—"), 1)
      ]),
      (__props.permit?.permit?.feeStateSeal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("dd", _hoisted_7, _toDisplayString(_ctx.$filters.usd(__props.permit?.permit?.feeStateSeal) || "—"), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("dd", _hoisted_10, _toDisplayString(_ctx.$filters.usd(__props.permit?.permit?.feeProcessing) || "—"), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("dd", _hoisted_13, _toDisplayString(_ctx.$filters.usd(__props.permit?.permit?.feeTotal) || "—"), 1)
      ])
    ]),
    _createElementVNode("form", {
      id: "payment-form",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (submit()), ["prevent"])),
      class: "mt-6"
    }, [
      _withDirectives(_createVNode(_component_tw_loading, null, null, 512), [
        [_vShow, stripeLoading.value]
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createVNode(_component_v_field, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_label, null, {
              default: _withCtx(() => [
                _createTextVNode("Email Address")
              ]),
              _: 1
            }),
            _createVNode(_component_v_input, {
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              type: "email",
              name: "email",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 512), [
          [_vShow, !stripeLoading.value]
        ])
      ]),
      _hoisted_15,
      _withDirectives(_createElementVNode("div", { class: "mt-4 text-red-600 text-sm" }, _toDisplayString(stripeError.value), 513), [
        [_vShow, stripeError.value.length]
      ]),
      _createVNode(_component_v_button, {
        id: "submit",
        class: "mt-8 w-full",
        color: "amber",
        type: "submit",
        loading: stripeLoading.value,
        disabled: stripeLoading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Pay Now ")
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ], 32)
  ], 64))
}
}

})